import React from 'react';
import styled from '@emotion/styled';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

const Container = styled.div`
  min-height: 100vh;
  background-color: #f5f5f7;
  padding: 2rem;
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  max-width: 800px;
  margin: 0 auto;
  background: white;
  padding: 2rem;
  border-radius: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  flex: 1;
`;

const Title = styled.h1`
  color: #1d1d1f;
  margin-bottom: 2rem;
  font-size: 2rem;
  text-align: center;
`;

const MarkdownContainer = styled.section`
  margin-bottom: 2rem;
  h1 {
    color: #1d1d1f;
    margin-bottom:0.5rem;
    font-size: 1.5rem;
  }
  h2 {
    color: #1d1d1f;
    margin-bottom: 0.5rem;
    font-size: 1.0rem;
  }

  p {
    color: #6e6e73;
    line-height: 1.6;
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
  }
`;

const Footer = styled.footer`
  text-align: center;
  padding: 1rem 0;
  color: #86868b;
  font-size: 0.9rem;
`;

function CodeReaderPrivacyPolicyJa() {
  const currentYear = new Date().getFullYear();
  const markdownContent = `
 # プライバシーポリシー

「QRコードリーダー: Fast」（以下「本アプリ」といいます。）は、ユーザーのプライバシーを尊重し、個人情報の保護に努めています。本アプリではユーザーの個人情報を収集せず、ユーザーのデータを保護するための措置を講じています。本プライバシーポリシー（以下「本ポリシー」といいます。）は、本アプリにおける情報の取り扱いについて定めたものです。

## 第1条（個人情報の収集および管理方針）

本アプリでは、ユーザーからの個人情報（氏名、住所、電話番号など）を一切収集いたしません。アプリ内のすべての機能は、個人情報の収集を行わないことを前提に設計されています。また、ユーザーのプライバシー保護のため、個人を特定できる情報の収集や保存は一切行いません。

## 第2条（ユーザーデータの保存）

本アプリでは、ユーザーがスキャンした結果はすべてユーザーの端末内に保存され、アプリ外部のサーバー等に保存されることはありません。このため、ユーザーがスキャンしたデータについては、本アプリおよび開発元では一切アクセスいたしません。また、これらのデータは第三者に提供されることもなく、ユーザーの端末内で安全に保管されることを保証します。

## 第3条（広告配信）

本アプリでは、Google AdMobを通じた広告配信を行っています。広告配信の過程において、Googleが提供するシステムにより広告配信の最適化のためのデータが自動的に収集される場合がありますが、これらのデータはGoogleのプライバシーポリシーに従って管理されます。本アプリでは、広告配信に関連する個人情報は一切保持しません。詳細については、Googleのプライバシーポリシーをご参照ください。

## 第4条（ユーザー権利とデータ管理）

本アプリは、ユーザーが自己のデータを完全に管理できるよう配慮しています。ユーザーはいつでもアプリ内のデータを削除することが可能であり、本アプリはユーザーの操作がない限りデータを外部に送信することはありません。また、利用規約に基づき、本アプリの利用に際して個人情報を利用しないため、情報の開示、訂正、削除、利用停止に関するリクエストには該当いたしません。

## 第5条（プライバシーポリシーの変更）

本アプリは、本ポリシーの内容を随時見直し、ユーザーのプライバシー保護の向上を図るため、法令の改正やアプリ機能の変更などに応じて本ポリシーを変更することがあります。変更があった場合、最新のプライバシーポリシーを本アプリ内に掲載することによりユーザーへ通知し、掲載と同時に効力を生じるものとします。ユーザーは、定期的に本ポリシーをご確認いただきますようお願いいたします。

## 第6条（お問い合わせ窓口）

本ポリシーに関するお問い合わせやご不明な点については、下記の連絡先までご連絡ください。

Eメールアドレス：linappworks@gmail.com
<br><br>
<div style="text-align: right;">以上</div>
  `;

  return (
    <Container>
      <Content>
        <Title>Privacy Policy</Title>
        <MarkdownContainer>
        <ReactMarkdown rehypePlugins={[rehypeRaw]}>{markdownContent}</ReactMarkdown>
        </MarkdownContainer>
      </Content>
      <Footer>
        <p>© {currentYear} linappworks. All rights reserved.</p>
      </Footer>
    </Container>
  );
}

export default CodeReaderPrivacyPolicyJa; 
